<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>حوافظ الايصالات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <PrintReceipts ref="PrintReceipts"> </PrintReceipts>
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عمل جميع العمليات على الايصالات المصدرة
              <div class="pull-left">
                <div class="btn-group">
                  <button type="button" class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown">
                    طباعة
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu pull-left" role="menu">
                    <li><a @click="printReceipt(records, 1)" href="javascript:void(0);"> جميع الايصالات</a></li>
                    <li><a href="#myModal" role="button" data-toggle="modal" > الحافظة </a></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class="row">
                <div class='col-lg-3 col-md-6 col-sm-6'>
                  <label>الفرع</label>
                  <select @change="UpdateBranchData()"  style="padding: 0px" class="form-control"  v-model="branch_id" >
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <tbDate :today='today' :mytitle='folderDateTitle' v-model= 'folder_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <label>المحصل/الفنى:</label>
                <div class="form-group input-group">
                  <span class="input-group-btn">
                    <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                      <button
                        @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                      </button>
                  </span>
                  <select class="form-control" style="padding: 0px" v-model="collector_id">
                    <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                      {{ collector.name }}
                    </option>
                  </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <div class="form-group">
                    <label>الترتيب</label>
                    <select class="form-control"  style="padding: 0px" v-model="sort">
                      <option value='cash_receipts.id'>رقم الايصال</option>
                      <option value='customers.region_id'>المنطقة</option>
                      <option value='customers.rec_id'>كود العميل</option>
                      <option value='customers.name'>الاسم</option>
                    </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  عرض حافظة الفنى
                  </button>
                </div>
                <div v-show="branch_id === 3 || branch_id === 4 || branch_id === 5 || branch_id === 6 || branch_id === 7 || branch_id === 9 || branch_id === 11 || branch_id === 12" class='col-lg-3 col-md-3 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click='DeleteRecept()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  حذف ايصالات الفرع
                  </button>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click="ResetReceipt()" href="#ResetReceipt" role="button" data-toggle="modal" type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  إفراغ حافظة
                  </button>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click="MoveReceipt()" href="#MoveReceipt" role="button" data-toggle="modal" type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  نقل حافظة لفنى
                  </button>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <span>&nbsp;</span>
                  <button @click='GetData1()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  عرض حافظة الفنى جديد
                  </button>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click="getItems()" href="#ItemsReceipt" role="button" data-toggle="modal" type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  اصناف الحافظة
                  </button>
                </div>
              </div>
              <br>
              <div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الكود</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>الايصال</th>
                      <th style='text-align: center'>تاريخ الاصدار</th>
                      <th style='text-align: center'>التأجيل</th>
                      <th style='text-align: center'>النوع</th>
                      <th style='text-align: center'>الحالة</th>
                      <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{fcolorgreen :record.status == 4,deleted :record.status == 3,fcolor :record.status == 1 || record.status == 5}" class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'> <i v-if='record.receipt_handles.length > 0'  data-toggle='modal' data-target='#OldHandelRecepts'  @click='showOldHandels(record)' class="fa fa-plus"></i> {{index +1 }}</td>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.customer_name}}</td>
                      <td align='center'>{{record.cash_receipt_id}}</td>
                      <td align='center'>{{record.create_date}}</td>
                      <td align='center'>{{record.delay}}</td>
                      <td align='center'>{{record.type_name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>
                        <button v-show="$per.value.convertReceipt" @click='printReceipt(record, 0)' type='button' class='btn btn-outline btn-info btn-xs' >طباعة</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>طباعة الحافظة</h4>
          </div>
          <div class='modal-body'>
            <div id="contentToPrint">
              <font size="2" face="Markazi Text" >
                <div class='col-lg-4 col-md-4 col-sm-4' >
                  تاريخ الحافظة {{from_date}}
                </div>
                <table style="border: 1px solid black;" width='100%'  id='dataTables-example'>
                  <thead>
                    <tr style="border: 1px solid black;">
                      <th style='border: 1px solid black;font-size: 20px;padding:2px;text-align: center'>م</th>
                      <th style='border: 1px solid black;font-size: 20px;padding:2px;text-align: center'>الكود</th>
                      <th width="200" style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>الاسم</th>
                      <th style='border: 1px solid black;font-size: 20px;padding:2px;text-align: center'>الايصال</th>
                      <th width="40"  style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>المدفوع</th>
                      <th width="40"  style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>الباقى</th>
                      <th width="80" style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>تسليم</th>
                      <th width="80" style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>تغيير</th>
                      <th style='border: 1px solid black;border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>ملاحظات الاتصال</th>
                      <th style='border: 1px solid black;font-size: 20px;padding:2px;text-align: center'>العروض</th>
                      <th style='border: 1px solid black;font-size: 20px;padding:2px;text-align: center'>المبلغ</th>
                      <th width="100" style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>المسئول</th>
                      <th width="30" style='border: 1px solid black;padding:2px;font-size: 20px;text-align: center'>TDS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="border: 1px solid black;" class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{index +1 }}</td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{record.rec_id}}</td>
                      <td style="border: 1px solid black;padding:2px 3px 0px 3px; font-size: 16px" align='right'>{{record.customer_name}}</td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{record.cash_receipt_id}}</td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px"></td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px"></td>
                      <td style="border: 1px solid black;padding:0px; font-size: 16px">
                        <table width='100%' >
                          <tr style="border: 1px solid black;padding:0px;;text-align: top">
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>1</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>2</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>3</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>4</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>5</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>6</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>7</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>8</td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                        </table>
                      </td>
                      <td style="border: 1px solid black;padding:0px; font-size: 16px">
                        <table width='100%' >
                          <tr style="border: 1px solid black;padding:0px;;text-align: top">
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>1</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>2</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>3</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>4</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>5</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>6</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>7</td>
                            <td style='border: 1px solid black;font-size: 10px;padding:0px;text-align: center'>8</td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                        </table>
                      </td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{record.notes}}</td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{record.offers}}</td>
                      <td style="border: 1px solid black;padding:2px; font-size: 16px" align='center'>{{record.amount}}</td>
                      <td style="border: 1px solid black;padding:2px 3px 0px 3px; font-size: 16px" align='center'>{{record.user_name}}</td>
                      <td style="border: 1px solid black;padding:2px 3px 0px 3px; font-size: 16px" align='center'></td>
                    </tr>
                  </tbody>
                </table>
              </font>
            </div>
          </div>
          <div class='modal-footer'>
            <button v-show="$per.value.printReceipt" v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' >
              <b> طباعة</b>
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- EditReceiptsModal Modal -->
    <div class='modal fade' id='EditReceiptsModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>تعديل ايصال</h4>
          </div>
          <AlterReceipt ref="AlterReceipt"> </AlterReceipt>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /EditReceiptsModal modal -->
    <!-- EditReceiptsModal Modal -->
    <div class='modal fade' id='DistributionByBarcode' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-md'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>اضافة ايصالات بقارئ الباركود</h4>
          </div>
          <DistributionReceipts ref="DistributionReceipts"> </DistributionReceipts>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /EditReceiptsModal modal -->
    <!-- ResetReceiptModal Modal -->
    <div class='modal fade' id='ResetReceipt' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' >
      <div class='modal-dialog  modal-sm'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>إفراغ حافظة</h4>
          </div>
          <ResetReceipt ref="ResetReceipt"> </ResetReceipt>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /ResetReceiptModal modal -->
    <!-- MoveReceiptReceiptModal Modal -->
    <div class='modal fade' id='MoveReceipt' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel'>
      <div class='modal-dialog  modal-sm'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>نقل حافظة</h4>
          </div>
          <MoveReceipt ref="MoveReceipt"> </MoveReceipt>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /MoveReceiptReceiptModal modal -->
    <!-- /.container-fluid -->
    <!-- Modal -->
    <div class='modal fade' id='ItemsReceipt' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel'>
        <div class='modal-dialog  modal-sm'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                    <h4 class='modal-title' id='myModalLabel'>أصناف الحافظة</h4>
                </div>
                <div class='modal-body'>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                    <thead>
                      <tr>
                        <th style='text-align: center'>الصنف</th>
                        <th style='text-align: center'>العدد</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class='odd gradeX' v-for='record in receiptItems' :key='record.id'>
                        <td align='center'>{{record.item}}</td>
                        <td align='center'>{{record.total_count}}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div class='modal-footer'>
                      <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                  </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class='modal fade' id='OldHandelRecepts' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
        <div class='modal-dialog  modal-lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <button type='button' class='close'  data-toggle='modal' data-target='#OldHandelRecepts' aria-hidden='true'>&times;</button>
                    <h4 class='modal-title' id='myModalLabel'>حالات سابقة</h4>
                </div>
                <form role='form'>
                <div class='modal-body'>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الحافظة</th>
                        <th style='text-align: center'>الفنى</th>
                        <th style='text-align: center'>التأجيل</th>
                        <th style='text-align: center'>المستخدم</th>
                        <th style='text-align: center'>الحالة</th>
                        <th style='text-align: center'>تاريخ التغيير</th>
                        <th style='text-align: center'>ملاحظات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class='odd gradeX' v-for='(record,index) in handeRecords' :key='index'>
                        <td align='center'>{{index +1 }}</td>
                        <td align='center'>{{record.folder_date}}</td>
                        <td align='center'>{{record.name}}</td>
                        <td align='center'>{{record.delay}}</td>
                        <td align='center'>{{record.user_name}}</td>
                        <td align='center'>{{record.type}}</td>
                        <td align='center'>{{record.create_date}}</td>
                        <td align='center'>{{record.notes}}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div class='modal-footer'>
                      <button type='button' class='btn btn-default' data-toggle='modal' data-target='#OldHandelRecepts'>خروج</button>
                  </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>
<style>
.fcolor {
   color: #FF0000;
}
.fcolorgreen {
   color: #0BB21A;
}
.deleted {
  text-decoration: line-through;
  color: #FF0000;
}
</style>
<style>
  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
<script>
import axios from 'axios'
import DistributionReceipts from '@/components/Sales/DistributionReceipts'
import PrintReceipts from '@/components/Sales/PrintReceipts'
import tbDate from '@/components/myComponents/tbDate'
import AlterReceipt from './AlterReceipt'
import ResetReceipt from './ResetReceipt'
import MoveReceipt from './MoveReceipt'
import Swal from 'sweetalert2'
export default {
  components: {
    PrintReceipts,
    AlterReceipt,
    DistributionReceipts,
    MoveReceipt,
    ResetReceipt,
    tbDate
  },
  name: 'PrintCollectingstatement',
  data () {
    return {
      receiptItems: [],
      isgetTec: false,
      type_id: 0,
      emptyRec: [{id: 0, name: ''}],
      sort: 'cash_receipts.id',
      today: true,
      folderDateTitle: 'تاريخ الحافظة',
      from_date: '',
      to_date: '',
      folder_date: '',
      teles: [],
      tele_id: '',
      validationErrors: '',
      records: {},
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      branches: {},
      branch_id: 0,
      modelCollectors: {},
      collectors: {},
      CollectorRecords: [],
      collector_id: '0',
      modelCollectorId: '',
      cashReceipts: '',
      handeRecords: '',
      id: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    this.UpdateBranchData()
  },
  methods: {
    // ========================================================
    getTec () {
      this.isgetTec = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'get-folder-tec', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        folder_date: this.folder_date
      })
        .then(({ data }) => {
          this.collectors = data
          this.isgetTec = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.isgetTec = false
          this.validationErrors = err.response.data.errors
        })
    },
    // ===========================================================
    showOldHandels (rec) {
      this.handeRecords = rec.receipt_handles
    },
    // ========================================================
    UpdateBranchData () {
      this.collector_id = 0
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
    },
    // =====================================================
    changeCollectors () {
      this.records = ''
    },
    // =====================================================
    GetDistributedByBarcode () {
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-distributed-receipts', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.$refs.DistributionReceipts.loadCom(data.Cash_receipts, data.Collectors)
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // =====================================================
    GetDistributedReceipts () {
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = false
      this.CollectorRecords = []
      this.cashReceipts = []
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-distributed-receipts', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.records = ''
          this.cashReceipts = data.Cash_receipts
          this.modelCollectors = data.Collectors
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-folder-receipts-for-print', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        sort: this.sort,
        folder_date: this.folder_date,
        collector_id: this.collector_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    GetData1 () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-folder-receipt1', {
        token: localStorage.getItem('token'),
        sort: this.sort,
        folder_date: this.folder_date,
        collector_id: this.collector_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    getItems () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-tec-receipt-items', {
        token: localStorage.getItem('token'),
        folder_date: this.folder_date,
        collector_id: this.collector_id
      })
        .then(({ data }) => {
          this.receiptItems = data
          this.isLoadingData = false
        })
    },
    // ===========================================================
    ResetReceipt () {
      this.$refs.ResetReceipt.pageLoad()
    },
    // ===========================================================
    MoveReceipt () {
      this.$refs.MoveReceipt.pageLoad()
    },
    // ===========================================================
    getReceiptsData () {
    },
    // ===========================================================
    async printReceipt (rec, typeId) {
      var xRate = 0
      var yRate = 0
      var paperSize = 0
      await axios.post(this.$apiURL + 'get-printer-rate', {
        token: localStorage.getItem('token'),
        id: this.branch_id
      })
        .then(({ data }) => {
          xRate = data.x_rate
          yRate = data.y_rate
          paperSize = data.paper_size
        })
      if (typeId === 0) {
        var Receipts = []
        Receipts.push(rec)
        if (paperSize === 0) {
          this.$refs.PrintReceipts.createPDF(Receipts, xRate, yRate)
        } else {
          this.$refs.PrintReceipts.CreatePDF_A5(Receipts, xRate, yRate)
        }
      } else {
        for (let i = 0; i < rec.length; i = i + 100) {
          // this.$refs.PrintReceipts.newCreatePDF(rec.slice(i, i + 100), xRate, yRate)
          if (paperSize === 0) {
            this.$refs.PrintReceipts.createPDF(rec.slice(i, i + 100), xRate, yRate)
          } else {
            this.$refs.PrintReceipts.CreatePDF_A5(rec.slice(i, i + 100), xRate, yRate)
          }
        }
      }
    },
    // ===========================================================
    getRec (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        evt.preventDefault()
        let i = this.cashReceipts.map(record => record.id).indexOf(parseInt(this.id))
        if (i > -1) {
          let r = this.CollectorRecords.map(record => record.id).indexOf(parseInt(this.id))
          if (r === -1) {
            this.CollectorRecords.push(Array.from(this.cashReceipts)[i])
            this.id = ''
          } else {
            this.$refs.id.select()
          }
        } else {
          this.$refs.id.select()
        }
      } else {
        return true
      }
    },
    // ===========================================================
    saveData () {
      let Receipts = []
      this.CollectorRecords.forEach(element =>
        Receipts.push(element.id)
      )
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'set-distributed-receipts', {
        token: localStorage.getItem('token'),
        CollectorId: this.modelCollectorId,
        folderDate: this.folder_date,
        receipts: Receipts
      })
        .then(res => {
          this.isLoadingSave = false
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    },
    // ===========================================================
    deleteRec (recID) {
      let i = this.CollectorRecords.map(record => record.id).indexOf(recID)
      this.CollectorRecords.splice(i, 1)
    },
    // ===========================================================
    DeleteRecept () {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف جميع ايصالات الفرع الحالى لذا تأكد من اختيارك الفرع المطلوب!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'empty-receipts', {
            token: localStorage.getItem('token'),
            branch_id: this.branch_id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف الايصالات بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              this.records = []
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateMaintenanceStatement.vue